import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ImageCard from "./comp/image_card";
import { AREAS } from "../data/devices";
import { api } from "../api";

const MasterControls = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [msg, setMsg]       = useState("");

  async function trigger(action) {
    setStatus("loading");
    setMsg(`Sending ${action.toUpperCase()} to all lights…`);
    try {
      const res = await api[action === "on" ? "masterOn" : "masterOff"]();
      setStatus("done");
      setMsg(`All lights turned ${action.toUpperCase()} (${res.count} commands sent)`);
    } catch (err) {
      setStatus("error");
      setMsg(err.message || "Failed");
    }
    setTimeout(() => { setStatus("idle"); setMsg(""); }, 4000);
  }

  return (
    <div style={{
      background: "#141414",
      border: "1px solid #222",
      borderLeft: "2px solid #c8a84b",
      borderRadius: 8,
      padding: "10px 16px",
      marginBottom: 20,
      display: "flex",
      alignItems: "center",
      gap: 16,
    }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: "#c8a84b", letterSpacing: "1px", textTransform: "uppercase", flex: 1 }}>
        Master
        {status !== "idle" && (
          <span style={{
            marginLeft: 10,
            fontWeight: 400,
            letterSpacing: 0,
            textTransform: "none",
            color: status === "loading" ? "#c8a84b" : status === "done" ? "#3a6b4a" : "#9b5050",
          }}>
            {msg}
          </span>
        )}
      </span>
      <button
        disabled={status === "loading"}
        onClick={() => trigger("on")}
        style={{
          padding: "6px 16px",
          background: status === "loading" ? "#1e1e1e" : "#c8a84b",
          color: status === "loading" ? "#444" : "#0a0a0a",
          border: "none", borderRadius: 6,
          fontWeight: 700, fontSize: 12,
          cursor: status === "loading" ? "not-allowed" : "pointer",
          letterSpacing: "0.3px",
        }}
      >
        All ON
      </button>
      <button
        disabled={status === "loading"}
        onClick={() => trigger("off")}
        style={{
          padding: "6px 16px",
          background: "transparent",
          color: status === "loading" ? "#333" : "#9b5050",
          border: `1px solid ${status === "loading" ? "#222" : "rgba(139,53,53,0.5)"}`,
          borderRadius: 6,
          fontWeight: 700, fontSize: 12,
          cursor: status === "loading" ? "not-allowed" : "pointer",
          letterSpacing: "0.3px",
        }}
      >
        All OFF
      </button>
    </div>
  );
};

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <MasterControls />

      <div className="card-container">
        {AREAS.map((item, index) => (
          <div
            key={index}
            onClick={() =>
              navigate("/dynamic", {
                state: {
                  title:          item.title,
                  imgSrc:         item.src,
                  buttonNames:    item.buttonNames,
                  commandMapping: item.commandMapping,
                },
              })
            }
          >
            <ImageCard src={item.src} title={item.title} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
